import { Viol3HistorikResponseDTO } from "~app/common/models/integration/viol3/Viol3HistorikResponseDTO";
import { Viol3HistorikLogEntryDTO } from "~app/common/models/integration/viol3/Viol3HistorikLogEntryDTO";
import { DateUtils } from "~app/common/utils/date-utils";
export class VirkesorderEventsViewModel {
    originalContractEvents: IContractEventViewModel[];
    deliverysourceEvents: IContractEventViewModel[];
    forestloggingEvents: IContractEventViewModel[];
    orderConfirmationEvents: IContractEventViewModel[];
    loadTenderLogEvents: IContractEventViewModel[];

    constructor(virkesorderEvent: Viol3HistorikResponseDTO) {
        this.originalContractEvents = virkesorderEvent.originalContractLogEntries.map(x => (this.getEventViewModel(x)));
        this.deliverysourceEvents = virkesorderEvent.deliverySourceEntries.map(x => (this.getEventViewModel(x)));
        this.forestloggingEvents = virkesorderEvent.forestloggingLogEntries.map(x => (this.getEventViewModel(x)));
        this.orderConfirmationEvents = virkesorderEvent.orderConfirmationLogEntries.map(x => (this.getEventViewModel(x)));
        this.loadTenderLogEvents = virkesorderEvent.loadTenderLogEntries.map(x => (this.getEventViewModel(x)));
    }

    private getEventViewModel(data: Viol3HistorikLogEntryDTO): IContractEventViewModel {
        return {
            event: data.event,
            datum: DateUtils.formatDateString(data.datum, DateUtils.datetimeformatWithoutMillis),
            anvandare: data.anvandare,
            hidden: data.hidden
        };
    }
}

export interface IContractEventViewModel {
    event: string;
    datum: string;
    anvandare: string;
    hidden: boolean;
}
